import { Text } from '@mantine/core';

import { TRACKING_CONFIGS } from '../../constants/conversionTracking';
import ErrorBox from './ResultBox/ErrorBox';
import ManualSuccessBox from './ResultBox/ManualSuccessBox';

import type { IFileUploadStatus } from '../../../../../../../../shared/apis/ai-agent/file/types';

interface IPropsManualConversionResult {
  uploadHistory: Pick<IFileUploadStatus, 'fileName' | 'failReason' | 'status'>;
}

export default function ManualConversionResult(props: IPropsManualConversionResult) {
  const { uploadHistory } = props;
  const { fileName, failReason, status } = uploadHistory;
  const successMessage = TRACKING_CONFIGS.manual.successMessages[status];

  if (!status) return null;

  if (status.includes('FAIL')) {
    return (
      <>
        <Text fw={500} mb="xs">
          문서 변환 진행 결과
        </Text>
        <ErrorBox result={{ fileName, errorMessage: failReason }} />
      </>
    );
  }

  if (successMessage && failReason) {
    return (
      <>
        <Text fw={500} mb="xs">
          문서 변환 진행 결과
        </Text>
        <ManualSuccessBox message={successMessage} fileName={fileName} href={failReason} />
      </>
    );
  }

  return null;
}
